type MonitoringLevel = 'info' | 'warn' | 'error';

interface MonitoringPayload {
  context: string;
  message: string;
  metadata?: Record<string, unknown>;
}

function emitToConsole(level: MonitoringLevel, payload: MonitoringPayload) {
  const logger = level === 'error' ? console.error : level === 'warn' ? console.warn : console.info;
  logger(`[monitoring:${payload.context}] ${payload.message}`, payload.metadata ?? {});
}

export function trackEvent(context: string, message: string, metadata?: Record<string, unknown>) {
  emitToConsole('info', { context, message, metadata });
}

export function trackWarning(context: string, message: string, metadata?: Record<string, unknown>) {
  emitToConsole('warn', { context, message, metadata });
}

export function trackError(context: string, error: unknown, metadata?: Record<string, unknown>) {
  const message = error instanceof Error ? error.message : 'Erro desconhecido';
  const errorMetadata =
    error instanceof Error
      ? {
          stack: error.stack,
          name: error.name,
          ...metadata,
        }
      : metadata;

  emitToConsole('error', {
    context,
    message,
    metadata: errorMetadata,
  });
}

export function setupGlobalMonitoring() {
  window.addEventListener('error', (event) => {
    trackError('window.error', event.error ?? event.message, {
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    trackError('window.unhandledrejection', event.reason);
  });

  if ('PerformanceObserver' in window) {
    try {
      const observer = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          if (entry.entryType === 'navigation') {
            trackEvent('performance.navigation', 'Métricas de navegação capturadas', {
              duration: Math.round(entry.duration),
              type: (entry as PerformanceNavigationTiming).type,
            });
          }
        }
      });

      observer.observe({ entryTypes: ['navigation'] });
    } catch (error) {
      trackWarning('performance.observer', 'Não foi possível iniciar observador de performance', {
        reason: error instanceof Error ? error.message : 'desconhecido',
      });
    }
  }
}
